import {ControllerBase} from "../../../../controllerBase";
import {parametroSistema} from "../../parametros/parametroController";
import {enderecoController} from "../../comum/enderecoController";
import global from 'globalMU'


declare var window:any
var NumeroEBairroObrigatorio:any

export const EditarEnderecoClienteController = ControllerBase.extend({
    name: "EditarEnderecoClienteController",
    framework: "knockout",
    bindingRegion: "#form-editar-endereco",

    ajax: function() {
        this.NumeroEBairroObrigatorio = NumeroEBairroObrigatorio = parametroSistema.obter("BAIRRO_NUMERO_OPCIONAL_CADASTRO_CLIENTE").Valor !== "S"; // FNX-6017 - FNX-6101
        return {
            url: "/Cliente/_EditarEndereco",
            type: "post",
            cache: false,
            data: {
                numeroCpfCnpj: this.cliente.CpfCnpj(),
                clienteNaoCadastrado: this.clienteNaoCadastrado,
            }
        };
    },

    bairrosPreCadastradosSelect2Options: {
        ajax: {
            url: "/Comum/ListarBairrosPreCadastrados",
            method: "post",
            data: function(params) {
                return {
                    bairro: params.term
                };
            },
            processResults: function(data, page) {

                if (data.Error) {
                    return { results: null };
                }

                return {
                    results: $.map(data,
                        function(item) {
                            return { id: item.Nome, text: item.Nome };
                        })
                };
            }
        },
        delay: 250,
        dataType: "json",
        minimumInputLength: 1
    },

    antesRenderizacaoCompleta: function(region) {

        if (!region) {
            return;
        }

        if (!this.model.Codigo || !this.model.Codigo()) {
            region.$el.attr("breadcrumb", "Novo Endereço");
        }
    },

    antesBinding: function () {

        if (this.model.Bairro && this.model.Bairro()) {

            if (!this.model.BairrosPreCadastrados) {
                this.appendToModel({ name: "BairrosPreCadastrados", value: [] });
            }
            this.model.BairrosPreCadastrados.removeAll();
            this.model.BairrosPreCadastrados([{ Nome: this.model.Bairro() }]);
        }

        if (this.model.CodigoCidade && this.model.CodigoCidade()) {
            this.codigoCidade = this.model.CodigoCidade();
        }

        if (this.model.NomeCidade && this.model.NomeCidade()) {
            this.nomeCidade = this.model.NomeCidade();
        }

        this.appendToModel({ name: 'HabilitarPesquisaCEP', value: true });
        this.model.Cep.subscribe($.proxy(this.controlarPesquisaCEP, this));

    },

    newModel: function() {

        return {
            Tipo: 6,
            DescricaoClassificacoes: "Ambos",
            Classificacoes: [],
            Cep: null,
            Logradouro: null,
            Numero: null,
            Complemento: null,
            Bairro: null,
            BairroPreCadastrado: null,
            BairrosPreCadastrados: [],
            Referencia: null,
            CodigoEstado: null,
            SiglaUf: null,
            CodigoCidade: null,
            NomeCidade: null,
            Novo: true,
            selecionado: false,
            adicionado: false,
            PermitirEditar: true
        };
    },

    aposBinding: function () {

        this.enderecoController = new enderecoController()
        this.controlarPesquisaCEP()
        $("input").on('focus', function () { $(this).select(); });
        $("[name='Cep']").validate($.proxy(this.validarTamanhoCep, this)); //422622
    },


    formConfig: {
        selector: "#form-editar-endereco",
        submit: {
            selector: "#salvar-endereco",
            loadingText: "Aguarde...",
            callback: "salvar",
            type: "model",
            modelType: "knockout"
        },
        rules: {
            'Classificacoes': {
                required: true
            },
            'Logradouro': {
                required: true
            },
            'Numero': {
                required: NumeroEBairroObrigatorio
            },
            'Bairro': {
                required: NumeroEBairroObrigatorio
            },
            'Uf': {
                required: true
            },
            'Cidade': {
                required: true
            },
            'Cep': {
                required: true
            }
        },
        messages: {
            'Classificacoes': {
                required: 'O campo "Tipo" é obrigatório.'
            },
            'Logradouro': {
                required: 'O campo "Logradouro" é obrigatório.'
            },
            'Numero': {
                required: 'O campo "Número" é obrigatório.'
            },
            'Bairro': {
                required: 'O campo "Bairro" é obrigatório.'
            },
            'Uf': {
                required: 'O campo "UF" é obrigatório.'
            },
            'Cidade': {
                required: 'O campo "Cidade" é obrigatório.'
            },
            'Cep': {
                required: 'O campo "CEP" é obrigatório.'
            }

        }

    },

    controlarPesquisaCEP: function(){
        this.model.HabilitarPesquisaCEP(!this.model.Cep() || this.model.Cep() === "");
    },

    listarCidades: function(codigoEstado) {

        if (!codigoEstado) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Comum/ListarCidadesPorEstado",
            type: "post",
            data: {
                codigoEstado: codigoEstado
            },
            success: function(data) {
                self.model.cidades(data);

                if (self.codigoCidade) {
                    self.model.CodigoCidade(self.codigoCidade);
                    self.codigoCidade = null;
                }

                if (self.nomeCidade) {
                    self.model.NomeCidade(self.nomeCidade);
                    self.nomeCidade = null;
                }

            }
        });

    },

    validarTamanhoCep: function (e, ocultarMensagem) { // 422622
        var cep = e.target ? $(e.target).val() : this.model.Cep();
        cep = global.replaceAll(cep, ".", "");
        cep = global.replaceAll(cep, "-", "");
        cep = global.replaceAll(cep, "/", "");
        cep = global.replaceAll(cep, "_", "");
        if (cep.length < 8) {
            if (ocultarMensagem == undefined || ocultarMensagem == false)
                global.showErrorMessage("CEP precisa ter 8 números"); // 423349
            return false;
        }
        return true;
    },

    obterEnderecoCep: function(e) {

        if (!e) {
            return;
        }

        if (e.preventDefault) {
            e.preventDefault();
        }

        if (typeof e == "string") this.model.Cep(e.trim());

        var cep = e.target ? $(e.target).val() : this.model.Cep();

        if (!cep || cep == "" || cep.length < 8) {
            return;
        }
        if (!this.validarTamanhoCep(e)) // 423349
            return;

        this.enderecoController.obterEnderecoPorCep(cep, $.proxy(this.preencherEndereco, this));

    },

    pesquisarCep: function () {
        this.enderecoController.obterCepPorEndereco(this.model, 1, $.proxy(this.obterEnderecoCep, this));
    },

    preencherEndereco: function (data) {

        if (!data) {
            return;
        }

        this.model.Logradouro(data.Logradouro);

        if (data.Bairro != "undefined") {
            if (!this.model.BairrosPreCadastrados) {
                this.appendToModel({ name: "BairrosPreCadastrados", value: [] });
            }
            this.model.BairrosPreCadastrados.removeAll();
            this.model.BairrosPreCadastrados([{ Nome: data.Bairro }]);
        }
        this.model.Bairro(data.Bairro);

        this.codigoCidade = data.Cidade.Codigo;
        this.nomeCidade = data.Cidade.Nome;

        if (this.model.CodigoEstado() == data.Estado.Codigo) {

            this.model.CodigoCidade(this.codigoCidade);
            this.codigoCidade = null;

        } else {
            this.model.CodigoEstado(data.Estado.Codigo);
            this.model.SiglaUf(data.Estado.Sigla);
        }
    },

    obterDescricaoClassificacoesSelecionados: function() {


        var selecionados = $("select[name=Classificacoes] option:selected");

        var classificacoes = "";
        var sep = "";

        $.each(selecionados,
            function() {

                classificacoes = classificacoes + sep + $(this).text();

                if (sep == "") {
                    sep = ", ";
                }

            });

        if (classificacoes) {

            if (!this.model.DescricaoClassificacoes) {
                this.appendToModel({ name: "DescricaoClassificacoes", value: classificacoes });
            } else {
                this.model.DescricaoClassificacoes(classificacoes);
            }

        }
    },

    obterSiglaUf: function() {

        var siglaUf = $("select[name=Uf] option:selected", this.region.$el).text();

        if (siglaUf) {

            if (!this.model.SiglaUf) {
                this.appendToModel({ name: "SiglaUf", value: siglaUf });
            } else {
                this.model.SiglaUf(siglaUf);
            }
        }

    },

    obterNomeCidade: function() {

        var cidade = $("select[name=Cidade] option:selected", this.region.$el).text();

        if (cidade) {

            if (!this.model.NomeCidade) {
                this.appendToModel({ name: "NomeCidade", value: cidade });
            } else {
                this.model.NomeCidade(cidade);
            }
        }

    },

    salvar: function(data, e) {

        e.preventDefault();

        if (!this.validarTamanhoCep(this, false))
            return false;

        //var existe = false;
        //var existeAmbos = false;

        //var self = this;

        //if ((!data.Codigo || !data.Codigo()) && this.cliente && this.cliente.Enderecos && this.cliente.Enderecos().length > 0) {

        //    $.each(this.cliente.Enderecos(), function () {

        //        if ((!self.endereco || !self.endereco.index || self.endereco.index() != this.index()) && this.Tipo() == '6') {
        //            existeAmbos = true;
        //        }

        //        if ((!self.endereco || !self.endereco.index || self.endereco.index() != this.index()) && data.Tipo() == this.Tipo()) {
        //            existe = true;
        //            return false;
        //        }
        //    });

        //    //var arr = global.where(enderecos, { Tipo: data.Tipo() });
        //    //existe = arr && arr.length > 0;

        //    //var arrAmbos = global.where(enderecos, { Tipo: '6' });
        //    //existeAmbos = arrAmbos && arrAmbos.length > 0;
        //}


        //if (!this.editando && this.cliente.Enderecos && this.cliente.Enderecos() && this.cliente.Enderecos().length > 0 && data.Tipo() == 6) {
        //    global.showErrorMessage('Não é possível adicionar um novo endereço do tipo Ambos.');
        //    return;
        //}
        //else if (this.editando && this.cliente.Enderecos && this.cliente.Enderecos() && this.cliente.Enderecos().length > 1 && data.Tipo() == 6) {
        //    global.showErrorMessage('Não é possível alterar o endereço para o tipo Ambos.');
        //    return;
        //}

        //if (existe) {
        //    global.showErrorMessage('Já existe um endereço do tipo selecionado adicionado.');
        //    return;
        //}

        //if (existeAmbos) {
        //    global.showErrorMessage('Não é possível adicionar um novo endereço, já existe um endereço do tipo "Ambos" adicionado.');
        //    return;
        //}


        if (this.editando) {
            this.endereco.Classificacoes(data.Classificacoes());
            this.endereco.DescricaoClassificacoes(data.DescricaoClassificacoes());
            this.endereco.Cep(data.Cep());
            this.endereco.Logradouro(data.Logradouro());
            this.endereco.Numero(data.Numero());
            this.endereco.Complemento(data.Complemento());
            this.endereco.Bairro(data.Bairro());
            this.endereco.Referencia(data.Referencia());
            this.endereco.CodigoEstado(data.CodigoEstado());
            this.endereco.SiglaUf(data.SiglaUf());
            this.endereco.CodigoCidade(data.CodigoCidade());
            this.endereco.NomeCidade(data.NomeCidade());
        }


        if (this.enderecoEditadoCallback) {
            this.enderecoEditadoCallback(data);
            if (this.model.adicionado) {
                this.model.adicionado(true);
            }
        }

    }

});

window.EditarEnderecoClienteController = EditarEnderecoClienteController
